import { connect } from 'react-redux';

import CustomSellerOrderDetails from '../../components/tools/CustomSellerOrderDetails';

function mapStateToProps(state) {
  return {
    selectedOrder: Object.assign({}, state.tools && state.tools.ordersSearch && state.tools.ordersSearch.selectedOrder),
  };
}
export const CustomSellerOrderDetailsContainer = connect(mapStateToProps)(CustomSellerOrderDetails);
export default CustomSellerOrderDetailsContainer;
